export const EDIT_COLLECTION_PATH_PREFIX = '/edit-collection';
export const COLLECTION_VIEWER_PREFIX = '/collection-viewer';
export const CONTENT_VIEWER_BAR_RAISER_PREFIX = '/content-viewer/bar-raiser';

export default {
  // Admin routes
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_EDIT_PERMISSIONS: '/admin/edit-permission',
  ADMIN_USER_PERMISIONS: '/admin/user-permissions',
  ADMIN_CONTENT_VIEWER: '/content-viewer/admin/:contentId',
  ADMIN_BATCH_UNPUBLISH: '/tools/batch-unpublish',

  // V2 content routes
  CONTENT_VIEW: '/view/:contentId',
  CONTENT_EDIT: '/edit/:contentId',

  // Techwriter routes
  TECH_WRITER_DASHBOARD: '/tech-writer/dashboard',
  TECH_WRITER_DASHBOARD_NEW: '/tech-writer/dashboard-new',
  TECH_WRITER_CONTENT_NOTES: '/tech-writer/content-notes/:contentId',
  TECH_WRITER_CONTENT_VIEWER: '/content-viewer/tech-writer/:contentId',
  TECH_WRITER_FINALIZING_VIEWR: '/content-finalizing-viewer/tech-writer/:contentId/:workflowId',

  // Publisher routes
  CONTENT_TO_PUBLISH: '/content-to-publish',
  CONTENT_TO_UPDATE: '/content-to-update',
  PUBLISHER_CONTENT_VIEWER: '/content-viewer/publisher/:contentId',

  // Reviewer routes
  CONTENT_TO_REVIEW: '/content-to-review',
  REVIEWER_CONTENT_VIEWER: '/content-viewer/reviewer/:contentId',

  // Author routes
  AUTHOR_CONTENT_VIEWER: '/content-viewer/author/:contentId',

  // Public routes
  CONTENT_REQUESTS: '/content-suggestions',
  CONTENT_REQUEST_CREATION: '/content-request-creation',
  CREATE_CONTENT: '/create-content',
  CREATE_POST: '/create-post',
  HOME_PAGE: '/',
  MY_CONTENT: '/my-content',
  MY_REVIEWS: '/my-reviews',
  MY_PENDING_COMMENTS: '/my-pending-comments',
  MY_REQUESTS: '/my-requests',

  // APGL user profile routes
  APGL_USER_PROFILE_REGISTRATION_FORM: '/user-profile-registration',
  APGL_USER_PROFILE_EDITING_FORM: '/user-profile',

  POST_VIEWER: '/post-viewer/:contentId',
  WHATS_NEW: '/whats-new',
  MANAGE_POSTS: '/manage-posts',

  // Bar Raiser
  BAR_RAISER_CONTENT_VIEWER: `${CONTENT_VIEWER_BAR_RAISER_PREFIX}/:contentId`,
  BAR_RAISER_QUESTIONNAIRE: '/bar-raiser/questionnaire/:contentId',
  BAR_RAISER_DASHBOARD: '/bar-raiser/dashboard-:techDomain',
  BAR_RAISER_DASHBOARD_PREFIX: '/bar-raiser/dashboard',

  // Download
  GET_ATTACHMENTS: '/get-attachments/:contentId/:attachmentId',

  // Content collection route
  CREATE_COLLECTION: '/create-collection',
  EDIT_COLLECTION: `${EDIT_COLLECTION_PATH_PREFIX}/:collectionId`,
  MY_COLLECTION: '/my-collection',
  COLLECTION_VIEWER: `${COLLECTION_VIEWER_PREFIX}/:collectionId`,
  ALL_COLLECTION: '/collections',
};
